export const apiUrl = process.env.VUE_APP_API_BASE_URL
export const externalApiUrl = process.env.VUE_APP_EXTERNAL_API_BASE_URL
export const externalApiKey = process.env.VUE_APP_EXTERNAL_API_KEY
export const env = process.env.VUE_APP_ENV
export const demoUrl = process.env.VUE_APP_DEMO_BASE_URL
export const emailBCC = process.env.VUE_APP_EMAIL_BCC
export const urlCall3cx = process.env.VUE_APP_3CX_BASE_URL
export const freshdeskBaseUrl = process.env.VUE_APP_FRESHDESK_BASE_URL
export const freshdeskEmail = process.env.VUE_APP_FRESHDESK_EMAIL
export const isProduction = process.env.VUE_APP_ENV === 'PRODUCTION'
